import { useEffect, useRef } from "react";

export default function MoleculeCanvas() {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let w = 0;
    let h = 0;
    let raf;
    let rot = 0;
    const mouse = { x: 0, y: 0, tx: 0, ty: 0 };

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const onMove = (e) => {
      mouse.tx = (e.clientX / window.innerWidth - 0.5) * 2;
      mouse.ty = (e.clientY / window.innerHeight - 0.5) * 2;
    };
    window.addEventListener("mousemove", onMove);

    const N = 30;
    const draw = () => {
      mouse.x += (mouse.tx - mouse.x) * 0.04;
      mouse.y += (mouse.ty - mouse.y) * 0.04;
      rot += 0.0032;
      ctx.clearRect(0, 0, w, h);

      const isNarrow = w < 768;
      const cx = w * 0.5;
      const top = h * 0.06;
      const span = h * 0.88;
      const radius = Math.min(w, h) * (isNarrow ? 0.22 : 0.18);

      const pts = [];
      for (let s = 0; s < 2; s++) {
        for (let i = 0; i < N; i++) {
          const t = i / (N - 1);
          const ang = t * Math.PI * 3.4 + rot + s * Math.PI;
          const x3 = Math.cos(ang) * radius;
          const z3 = Math.sin(ang) * radius;
          const depth = (z3 + radius) / (2 * radius);
          const scale = 0.82 + depth * 0.18;
          pts.push({
            x: cx + x3 * scale + mouse.x * 16 * depth,
            y: top + t * span + mouse.y * 12,
            depth,
          });
        }
      }

      ctx.lineWidth = 1;
      for (let i = 0; i < N; i += 2) {
        const a = pts[i];
        const b = pts[N + i];
        const alpha = 0.04 + 0.1 * a.depth;
        ctx.strokeStyle = `rgba(255,255,255,${alpha})`;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }

      for (const p of pts) {
        const r = 1 + p.depth * 2.4;
        ctx.fillStyle = `rgba(255,255,255,${0.1 + p.depth * 0.55})`;
        ctx.beginPath();
        ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
        ctx.fill();
      }

      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return <canvas ref={ref} aria-hidden="true" className="absolute inset-0 h-full w-full opacity-70 md:opacity-100" />;
}
